import { render, staticRenderFns } from "./VAlert.vue?vue&type=template&id=9b61d384&scoped=true&"
import script from "./VAlert.vue?vue&type=script&lang=js&"
export * from "./VAlert.vue?vue&type=script&lang=js&"
import style0 from "./VAlert.vue?vue&type=style&index=0&id=9b61d384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b61d384",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default})
